export default __webpack_public_path__ + "static/media/dosNu.7595472c.png";